<div class="calendar">
  <div class="calendar-view-only" *ngIf="!checkViewMode('edit')">
    <div class="selected-info">
      <div class="info-item">
        <strong>Data:</strong> {{ selectedDate }}
      </div>
      <div class="info-item">
        <strong>Horário:</strong> {{ selectedTime }}
      </div>
      <div class="info-item">
        <strong>Profissional:</strong> {{ selectedProfessional }}
      </div>
    </div>
  </div>  

  <ng-container *ngIf="checkViewMode('edit')">
    <div class="header">
      <button class="rounded-button button-primary-bg" (click)="today()">Hoje</button>
      <button class="text-button" (click)="previous()" [disabled]="isPreviousDisabled">&lt; Semana Anterior</button>
      <button class="text-button" (click)="next()" [disabled]="isNextDisabled">Próxima Semana &gt;</button>
    </div>

    <ng-container *ngIf="days.length > 0; else noTimes">
      <div class="days-row">
        <div class="day-column" *ngFor="let day of days">
          <div class="day-title day-title-primary">
            <div class="day-name">{{ day.date | date: 'EEEE' }}</div>
            <div class="day-date">{{ day.date | date: 'MMM dd' }}</div>
          </div>
          <div *ngFor="let time of day.times" 
               class="time-cell" 
               [ngClass]="{'time-cell-selected': time.selected, 'editable': checkViewMode('edit')}"
               (click)="checkViewMode('edit') ? selectTime(day, time) : null">
            {{ time.hour }}
            
            <div *ngIf="time.selected && getSelectedProfessionalName(time)"
              class="popover-info"
              [popover]="getSelectedProfessionalName(time)"
              placement="top"
              container="body"
              triggers="mouseenter:mouseleave">
              <i class="calendar-popover-info-icon">i</i>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #noTimes>
      <div class="no-availability-message">
        Não há horários disponíveis
      </div>
    </ng-template>
  </ng-container>

  <!-- Modal para seleção de profissional -->
  <div class="modal-backdrop" *ngIf="showProfessionalModal">
    <div class="modal-content">
      <h3>Escolha um profissional</h3>
      <div class="professional-options">
        <button *ngFor="let attribute of selectedTimeSlot.attributes"
                class="professional-button"
                (click)="confirmProfessionalSelection(attribute)">
          {{ getProfessionalName(attribute) }}
        </button>
      </div>
      <button class="close-button" (click)="showProfessionalModal = false">Fechar</button>
    </div>
  </div>
</div>